import {ActivityTimeline} from '@/shared/components/ui/activity-timeline'
import {usePatientTherapySequenceContext} from '@/shared/contexts/patient-therapy-sequence-context'
import {Tabs} from '@chakra-ui/react'
import {EventLogResources} from '@cypro/engine/utils'
import {DataSection} from '@cypro/ui/components/ui/data-section'
import {EmptyState} from '@cypro/ui/components/ui/empty-state'
import {useTranslate} from '@tolgee/react'
import {useMemo} from 'react'

export function HistoryTab() {
  const {t} = useTranslate('common')
  const {activities} = usePatientTherapySequenceContext()

  const {sequenceActivities, medicineActivities} = useMemo(() => {
    return {
      sequenceActivities: (activities ?? []).filter(a => a.resource === EventLogResources.patientTherapySequence),
      medicineActivities: (activities ?? []).filter(
        a => a.resource === EventLogResources.patientTherapySequenceMedicine
      ),
    }
  }, [activities])

  return (
    <Tabs.Content value="history" spaceY="6" pb="4">
      <DataSection label={t('prescription_activity')}>
        {sequenceActivities.length ? (
          <ActivityTimeline activities={sequenceActivities} />
        ) : (
          <EmptyState title={t('no_recorded_activity_yet')} />
        )}
      </DataSection>

      <DataSection label={t('medicine_activity')}>
        {medicineActivities.length ? (
          <ActivityTimeline activities={medicineActivities} />
        ) : (
          <EmptyState title={t('no_recorded_activity_yet')} />
        )}
      </DataSection>
    </Tabs.Content>
  )
}
